import styled from 'styled-components'
import { Button } from 'components/common'

export const ButtonStyled = styled(Button)`
  width: 100%;
  margin-bottom: 0px;

`
